import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { posts } from "./data";
import { useBlogs } from "../../../../hooks/apis/blog";

function Section4_posts() {
  const [limit, setlimit] = useState(6);
  const { data, isLoading } = useBlogs({ limit });
  useEffect(() => {
    var actual_width = window.innerWidth;
    if (actual_width < 767) {
      var slider = document.getElementById("ss");
      slider.setAttribute("slides-per-view", "1");
    }
  }, []);
  return (
    <swiper-container
      id="ss"
      dir="rtl"
      space-between="30"
      effect="slide"
      slides-per-view="3"
      speed="500"
      pagination-el=".post-pagination"
      pagination-clickable="true"
    >
      {data &&
        data.blogs?.map((post, index) => {
          return (
            <swiper-slide key={index}>
              <div className="post">
                <Link to={`blog/post/${post.slug}`}></Link>
                <div className="img-box">
                  <img
                    src={post.photo}
                    className="img-fluid"
                    title={post.title}
                    alt={post.title}
                  />
                </div>
                <div className="info-box">
                  <h3>{post.title}</h3>
                  <p>{post.description}</p>
                  <div className="detail">
                    <span className="comment-count">
                      <i className="fas fa-comment"></i>
                      {post.comments_count} نظر
                    </span>
                    <span className="date">
                      <i className="fas fa-calendar"></i>
                      {post.created_at}
                    </span>
                  </div>
                </div>
              </div>
            </swiper-slide>
          );
        })}
    </swiper-container>
  );
}

export default Section4_posts;
